export class EnumUtil {
    static toArray<T>(o: { [s: string]: T } | ArrayLike<T>): T[] {
        return Object.values(o);
    }
}
